









'use strict';

var InteractionManager={
current:{
createInteractionHandle:function createInteractionHandle(){},
clearInteractionHandle:function clearInteractionHandle(){}},

inject:function inject(manager){
InteractionManager.current=manager;
}};


module.exports=InteractionManager;


//////////////////
// WEBPACK FOOTER
// ./~/animated/lib/injectable/InteractionManager.js
// module id = 239
// module chunks = 0